import { checkFileDownloadTask, checkSystemAsyncTask } from '../../../../api'
import {
  isAsyncTaskFailedStatus,
  isAsyncTaskSuccessStatus,
} from '../../../../utils/async'
import { getFilesTotalSize } from '../../../../utils/file'

import {
  ARCHIVE_FILES_LIMIT_COUNT,
  ARCHIVE_FILES_LIMIT_SIZE,
  TASK_STATUS_INTERVAL,
} from './useFilesDownloadAll.constants'

export function checkDownloadArchiveTaskStatus({
  handler,
  outboundUuid,
  task,
}) {
  checkFileDownloadTask({ outboundUuid, taskId: task }).then(({ data }) => {
    if (isAsyncTaskSuccessStatus(data)) {
      handler(data)
    } else if (isAsyncTaskFailedStatus(data)) {
      handler()
    } else {
      setTimeout(
        () => checkDownloadArchiveTaskStatus({ handler, outboundUuid, task }),
        TASK_STATUS_INTERVAL
      )
    }
  })
}

export function checkAsyncTask({ handler, outboundUuid, task }) {
  checkSystemAsyncTask({ id: task }).then(({ data }) => {
    if (
      isAsyncTaskFailedStatus(data) ||
      isAsyncTaskFailedStatus(data?.result)
    ) {
      handler(data?.result)
    } else if (isAsyncTaskSuccessStatus(data)) {
      checkDownloadArchiveTaskStatus({
        handler,
        outboundUuid,
        task: data?.result?.task_id,
      })
    } else {
      setTimeout(
        () => checkAsyncTask({ handler, outboundUuid, task }),
        TASK_STATUS_INTERVAL
      )
    }
  })
}

export function isOverLimitFiles(files) {
  const filesSize = getFilesTotalSize(files)

  return (
    files.length > ARCHIVE_FILES_LIMIT_COUNT ||
    filesSize > ARCHIVE_FILES_LIMIT_SIZE
  )
}
